import { Typography } from '@mui/material';
import { pluralize } from '@bymason/utils';
import { MoveDevicesToGroupResult } from '@bymason/controller-api-hooks';
import { ControllerAlert as Alert } from '@bymason-private/legacy-pattern-components';

export default function MoveDevicesAlert({
  moveDevicesResult,
  targetGroup,
  deviceCount,
}: MoveDevicesAlertProps) {
  if (moveDevicesResult.willWipe && moveDevicesResult.willUpdate) {
    return (
      <Alert severity='warning' variant='outlined'>
        <Typography>
          This action will result in <strong>{deviceCount}</strong> selected{' '}
          {pluralize(deviceCount)`${['device', 'devices']}`} to be <strong>WIPED</strong> immediately causing
          the devices to restart.
        </Typography>
        <Typography>
          Additionally, the selected devices will update to the{' '}
          <strong>{moveDevicesResult.newProject}</strong> project version{' '}
          <strong>{moveDevicesResult.newVersion}</strong> and receive any app updates deployed to the{' '}
          <strong>{targetGroup}</strong> group.
        </Typography>
      </Alert>
    );
  } else if (moveDevicesResult.willWipe) {
    return (
      <Alert severity='warning' variant='outlined'>
        <Typography>
          This action will result in <strong>{deviceCount}</strong> selected{' '}
          {pluralize(deviceCount)`${['device', 'devices']}`} to be <strong>WIPED</strong> immediately causing
          the devices to restart.
        </Typography>
      </Alert>
    );
  } else if (moveDevicesResult.willUpdate) {
    return (
      <Alert severity='warning' variant='outlined'>
        <Typography>
          This action will result in <strong>{deviceCount}</strong> selected{' '}
          {pluralize(deviceCount)`${['device', 'devices']}`} to update to the{' '}
          <strong>{moveDevicesResult.newProject}</strong> project version{' '}
          <strong>{moveDevicesResult.newVersion}</strong> and receive any app updates deployed to the{' '}
          <strong>{targetGroup}</strong> group.
        </Typography>
      </Alert>
    );
  } else {
    return (
      <Alert severity='warning' variant='outlined'>
        <Typography>
          This action will move <strong>{deviceCount}</strong> selected{' '}
          {pluralize(deviceCount)`${['device', 'devices']}`} to the <strong>{targetGroup}</strong> group
        </Typography>
      </Alert>
    );
  }
}

interface MoveDevicesAlertProps {
  moveDevicesResult: MoveDevicesToGroupResult;
  targetGroup: string;
  deviceCount: number;
}
